import { useMemo, useEffect, cloneElement, useCallback } from 'react';
import { countImgsInLayout, hasTagName } from './utils';
export function useOnImgRendered(element, ref, onRendered) {
    if (onRendered === void 0) { onRendered = function () { }; }
    var imgInLayout = useMemo(function () { return countImgsInLayout(element); }, [element]);
    var renderedImgCount = 0;
    var handleOnRendered = useCallback(function (e) {
        if (hasTagName(e === null || e === void 0 ? void 0 : e.target, 'img')) {
            renderedImgCount += 1;
        }
        if (renderedImgCount >= imgInLayout) {
            onRendered();
        }
    }, [imgInLayout]);
    useEffect(function () {
        if (imgInLayout === 0) {
            onRendered();
        }
    });
    var clonedElement = cloneElement(element, {
        ref: ref,
        onLoad: handleOnRendered,
        onError: handleOnRendered,
    });
    return clonedElement;
}
